import angular from 'angular';
import companyBenefitsComponent from './company-benefits.component';

let companyBenefitsModule = angular.module('companyBenefitsModule', [

])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('companyBenefits', companyBenefitsComponent);

export default companyBenefitsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/company-benefits/company-benefits.js